import dateAdapter from "utils/dateAdapter";
import moment from 'moment';
import { getConfig } from 'config';

export const SaleCreationDate = ({ original }) => {
  if (getConfig('customConfig.dates.useVerboseFormat')) {
    let momentDate;
    
    if (original.dateTime) {
      momentDate = moment(original.dateTime);
    } else if (original.dateTimeTimestamp) {
      momentDate = moment.utc(original.dateTimeTimestamp);
    } else if (original.dateTimeTimestampUTC) {
      momentDate = moment(original.dateTimeTimestampUTC);
    } else {
      momentDate = moment(original);
    }
    
    if (momentDate && momentDate.isValid()) {
      const formatted = momentDate.format('dddd DD [de] MMMM [de] YYYY - HH:mm');
      return formatted.charAt(0).toUpperCase() + formatted.slice(1);
    }
  }
  
  return dateAdapter(original, 'LL HH:mm');
};
